import { graphqlRequest, graphqlUpload } from "./client";
import { GATE_FIELDS, type StepGate } from "./types";

export interface CertificateView {
  step: {
    fileName?: string | null;
    contentType?: string | null;
    fileSize?: number | null;
    uploadedAt?: string | null;
    hasCertificate: boolean;
  };
  gate: StepGate;
  done: boolean;
}

/** Largest certificate PDF the server keeps as it is; photos and screenshots are shrunk instead. */
export const CERT_MAX_PDF = 2.5 * 1024 * 1024;
export const CERT_MAX_UPLOAD = 8 * 1024 * 1024;

const CERTIFICATE_FIELDS = `step { fileName contentType fileSize uploadedAt hasCertificate } ${GATE_FIELDS} done`;

/** Step 5: Certificate. */
export async function fetchCertificate(): Promise<CertificateView> {
  return (
    await graphqlRequest<{ getCertificate: CertificateView }>(
      `{ getCertificate { ${CERTIFICATE_FIELDS} } }`,
    )
  ).getCertificate;
}

/** Upload the Growth Pathway certificate (a PDF up to 2.5 MB, or a photo or screenshot). */
export async function uploadCertificate(file: File): Promise<CertificateView> {
  return (
    await graphqlUpload<{ uploadCertificate: CertificateView }>(
      `mutation($file: Upload!) { uploadCertificate(file: $file) { ${CERTIFICATE_FIELDS} } }`,
      {},
      "file",
      file,
    )
  ).uploadCertificate;
}

/** Complete Step 5: completes the Growth Pathway and opens the Gig Board. */
export async function completeCertificate(): Promise<CertificateView> {
  return (
    await graphqlRequest<{ completeCertificate: CertificateView }>(
      `mutation { completeCertificate { ${CERTIFICATE_FIELDS} } }`,
    )
  ).completeCertificate;
}
